import uuid from 'uuid'
import {setUserId} from './actions/actions';

export default class UserRequestProcessor
{
    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store)
    {
        this._store = store;
        this._dispatch = store.dispatch;
    }

    process(input)
    {
        let state = this._store.getState();
        let userId = state
            [this._settings.stateLocations.Conversation.Base]
            [this._settings.stateLocations.Conversation.userId];

        if(!userId){
            userId = uuid.v4();
        }

        this._dispatch(setUserId(
            userId, this._settings.stateLocations.Conversation.userId
        ));

        return Object.assign({}, input, {userId});
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/user/src/request-processor-user.js